<cfp-card>
  <div class="row">
    @if (isTranslationLoaded()) {
      <div class="card-title col">
        <h2 class="mb-0 me-2">
          {{ 'header.roadmap-module' | translate }}
          <div class="d-inline-block text-nowrap">
            {{ 'roadmap.from' | translate }}
            <cfp-energy-label class="d-inline-block align-middle" [energyLabel]="currentEnergyLabel()" [size]="'xs'" />
            {{ 'roadmap.to' | translate }}
            <cfp-energy-label class="d-inline-block align-middle" [energyLabel]="improvedEnergyLabel()" [size]="'xs'" />
          </div>
        </h2>
      </div>
    }
  </div>
  <cfp-table [columns]="columns()" [data]="rows()" [sortBy]="'year'" [sortOrder]="SortOrder.Descending">
    <ng-template let-entry="row" let-index="index">
      @let buildingReportRoadmapEntry = mapToBuildingReportRoadmap(entry);
      @for (measure of buildingReportRoadmapEntry.measureList; track measure; let rowIndex = $index) {
        @let labelGroupValue = labelGroup();
        @let entryEnergyLabel =
          labelGroupValue ? buildingReportRoadmapEntry.energyLabels?.[labelGroupValue] : undefined;
        @let measureCode = measure.code;
        @let measureBadge = measureCode ? measuresWithBadge()?.[measureCode] : undefined;
        @let impactEnergyLabel =
          labelGroupValue
            ? measure.userDefinedImpactEnergyLabels?.[labelGroupValue] || measure.impactEnergyLabels?.[labelGroupValue]
            : undefined;
        <tr>
          @if (rowIndex === 0) {
            <td [attr.rowspan]="buildingReportRoadmapEntry.measureList?.length" [class.bg-white]="!(index % 2 === 0)">
              {{ buildingReportRoadmapEntry.year }}
            </td>
            <td
              [attr.rowspan]="buildingReportRoadmapEntry.measureList?.length"
              class="border-end"
              [class.bg-white]="!(index % 2 === 0)"
            >
              @if (index === 0 && !entryEnergyLabel) {
                <cfp-energy-label class="d-inline-block align-middle" [energyLabel]="currentEnergyLabel()" size="sm" />
              } @else if (entryEnergyLabel) {
                <cfp-energy-label class="d-inline-block align-middle" [energyLabel]="entryEnergyLabel" size="sm" />
              } @else {
                <span>-</span>
              }
            </td>
          }

          <td class="default-padding">
            {{ measure.name || (`measure.name.${measure.code}` | translate) }}
            @if (measureBadge) {
              <cfp-badge>{{ measureBadge | translate }}</cfp-badge>
            }
            @if (measure.recognized && showRecognisedMeasureCheck()) {
              <cfp-icon icon="file-check" iconStyle="primary" />
            }
          </td>
          <td>{{ measure.investment | cfpCurrency: currencyCode() }}</td>
          <td
            [innerHtml]="measure?.paybackPeriodYears | paybackPeriod: measure.investment : measure.costReduction"
          ></td>
          <td [innerHtml]="measure?.calculatedCo2ConsumptionReduction"></td>
          <td [innerHtml]="impactEnergyLabel | labelImpactBar"></td>
        </tr>
      }
    </ng-template>
  </cfp-table>

  <div>
    @if (showRecognisedMeasureCheck()) {
      @if (customRecognizedMeasureIcon()) {
        <span [class]="customRecognizedMeasureIcon()"></span>
      } @else {
        <div class="recognized-measure-table-icon">
          <i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i>
          <span class="fa-stack fa-check-measure">
            <i class="fa fa-circle fa-stack-1x"></i>
            <i class="fa fa-check fa-stack-1x fa-inverse"></i>
          </span>
        </div>
      }
      <span class="ms-2">{{ 'measure.recognized' | translate }}</span>
      <cfp-info-modal-button
        class="ms-2"
        [title]="'measure.recognized'"
        body="measure.recognized.info"
        showContactInfo="true"
      />
    }
  </div>
</cfp-card>
